module.exports = __webpack_public_path__ + "static/media/giorgio-armani-si-passione-big.b49e9672.png";